"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signup = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_state_1 = require("../../components/input/input.state");
var input_state_group_1 = require("../../components/input/input.state.group");
var mithril_component_1 = require("../../components/mithril.component");
var submit_button_1 = require("../../components/submit.button");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var classnames_1 = require("../../util/classnames");
var auth_component_style_1 = require("../auth/auth.component.style");
var migrate_user_1 = require("../auth/migrate.user");
var signup_style_1 = require("./signup.style");
(0, theme_1.addStyles)(signup_style_1.Style);
function checkValidity(input, msg) {
    if (!input.isFilled) {
        input.setError(msg);
    }
    else {
        input.setError('');
    }
}
var Signup = /** @class */ (function (_super) {
    tslib_1.__extends(Signup, _super);
    function Signup(ctrl, inviteToken) {
        var _this = _super.call(this) || this;
        _this.form = new input_state_group_1.IkeInputStateGroup();
        _this.firstName = new input_state_1.InputState(index_1.T.SIGNUP_FIRST_NAME);
        _this.lastName = new input_state_1.InputState(index_1.T.SIGNUP_LAST_NAME);
        _this.firstNameValue = null;
        _this.lastNameValue = null;
        _this.ctrl = ctrl;
        _this.inviteToken = inviteToken;
        _this.autorun(function (_) { return _this.validate(); });
        return _this;
    }
    Object.defineProperty(Signup.prototype, "nodes", {
        get: function () {
            var _a, _b;
            var _this = this;
            return (0, mithril_1.m)('form', { className: auth_component_style_1.CSS.container }, [
                // First Name
                (0, mithril_1.m)('input', {
                    className: (0, classnames_1.classNames)(migrate_user_1.CSS.emailInput, (_a = {},
                        _a[migrate_user_1.CSS.emailInputHasError] = typeof this.firstNameValue === 'string' ? !Boolean(this.firstNameValue) : false,
                        _a)),
                    placeholder: (0, index_1.Translate)(index_1.T.SIGNUP_FIRST_NAME),
                    onkeyup: function (event) {
                        _this.firstNameValue = event.target.value;
                    },
                    value: this.firstNameValue,
                    disabled: this.ctrl.loading
                }),
                this.getValidationError(this.firstNameValue, index_1.T.SIGNUP_FIRST_NAME_INVALID),
                // Last Name
                (0, mithril_1.m)('div', { className: auth_component_style_1.CSS.padding }, (0, mithril_1.m)('input', {
                    className: (0, classnames_1.classNames)(migrate_user_1.CSS.emailInput, (_b = {},
                        _b[migrate_user_1.CSS.emailInputHasError] = typeof this.lastNameValue === 'string' ? !Boolean(this.lastNameValue) : false,
                        _b)),
                    placeholder: (0, index_1.Translate)(index_1.T.SIGNUP_LAST_NAME),
                    onkeyup: function (event) {
                        _this.lastNameValue = event.target.value;
                    },
                    value: this.lastNameValue,
                    disabled: this.ctrl.loading
                })),
                this.getValidationError(this.lastNameValue, index_1.T.SIGNUP_LAST_NAME_INVALID),
                (0, mithril_1.m)('div', { className: auth_component_style_1.CSS.padding }, submit_button_1.SubmitButton.view({
                    title: index_1.T.SIGNUP,
                    form: this.form,
                    submit: this.submit,
                    submitting: this.ctrl.loading,
                    disabled: !Boolean(this.firstNameValue) || !Boolean(this.lastNameValue),
                    className: auth_component_style_1.CSS.button,
                    noAccent: true
                }))
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Signup.prototype.getValidationError = function (value, error) {
        if (typeof value === 'string' ? Boolean(value) : true) {
            return null;
        }
        return (0, mithril_1.m)('div', {
            className: migrate_user_1.CSS.validationError
        }, (0, index_1.Translate)(error));
    };
    Signup.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Boolean(this.firstNameValue) || !Boolean(this.lastNameValue)) {
                            services_1.Logger.error('Attempted to submit invalid form...');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.ctrl.signupSSO(this.inviteToken, this.firstNameValue, this.lastNameValue)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Signup.prototype.validate = function () {
        checkValidity(this.firstName, index_1.T.SIGNUP_FIRST_NAME_INVALID);
        checkValidity(this.lastName, index_1.T.SIGNUP_LAST_NAME_INVALID);
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], Signup.prototype, "firstNameValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Signup.prototype, "lastNameValue", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], Signup.prototype, "submit", null);
    return Signup;
}(mithril_component_1.IMithrilStateComponent));
exports.Signup = Signup;
//# sourceMappingURL=signup.js.map